import React, { useContext, useEffect, useState } from 'react';

// Images
import Freetakistan from '../../assets/images/Freetakistan.png';
import ParceriaFree from '../../assets/images/parceria.jpg';

// Components
import Header from '../../components/Header/index';

// Material-ui
import { Typography, Button } from '@material-ui/core';

// Context
import AuthContext from '../../Context/context';

// Firebase
import { useFirebaseApp } from 'reactfire';

import './emailVerification.css';

const EmailVerification = () => {
    let firebase = useFirebaseApp();

    const { currentUser, isLogged } = useContext(AuthContext);
    const [sendEmail, setSendEmail] = useState(false);

    // Reenvio de verificação de email
    const sendAgainEmailVerification = async () => {
        await firebase.auth().onAuthStateChanged((user) => {
            // Caso usuário estiver autenticado, recupera o usuário atual
            if (user && !user.emailVerified) {
                user.sendEmailVerification()
                    .then(resp => {
                        setSendEmail(true);
                    })
                    .catch(err => {
                        console.log('Houve um erro no reenvio do link de verificação para o email destinatário.');
                    })
            }
        })
    }

    useEffect(() => {
        sendAgainEmailVerification();
    }, [])

    return (
        <div>
            <Header />

            <div className="email-verification">
                <div className='text-center'>
                    <img src={Freetakistan} alt='Freetakistan Logo' style={{ width: '150px' }} />
                </div>

                <br />
                <i><p style={{ textAlign: 'center', fontWeight: 'bold' }}>Verificação de E-mail</p></i>
                <hr />
                {
                    isLogged ?
                        <div>
                            <Typography component="h4" variant="h4" style={{ textAlign: 'center', marginBottom: '1em' }}>
                                Obrigado por se cadastrar no Free Takistan! =D
                            </Typography>

                            <div className='text-center'>
                                <img src={ParceriaFree} alt='Parceria FreeTakistan' style={{ width: '300px', borderRadius: '15px' }} />
                            </div>

                            <Typography component="h5" variant="h5" color="primary" style={{ textAlign: 'center', marginTop: '1em' }}>
                                Seu email <strong>"{currentUser?.email}"</strong> foi verificado e sua conta ativada! Você já pode utilizar sua conta do Free Takistan =)
                            </Typography>
                        </div>
                        :
                        <div>
                            <Typography component="h5" variant="h5" style={{ textAlign: 'center', marginBottom: '2em' }}>
                                Sua conta precisa ser verificada e foi enviado ao seu email <strong>"{currentUser?.email}"</strong> um link de verificação para ativar sua conta no Free Takistan.
                            </Typography>
                            <Typography component="article" variant="subtitle2" style={{ textAlign: 'center', marginBottom: '2em' }}>
                                O email pode demorar alguns minutos para chegar em sua caixa de entrada. É importante verificar se esta no <strong style={{ color: 'red' }}>lixo eletrônico</strong>, mas caso o email não chegue, atualize a página (F5).
                            </Typography>
                            {/* <div className="btn-center">
                                <Button variant="contained" id="btn-padrao" disabled={sendEmail} onClick={() => {
                                    sendAgainEmailVerification();
                                }}>
                                    {
                                        sendEmail ? 'Link de verificação reenviado!' : 'Reenviar Email'
                                    }
                                </Button>
                            </div> */}
                        </div>
                }
            </div>
        </div>
    );
}

export default EmailVerification;